import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { AlertService } from '../../services/alert.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  alertMsg: Observable<string> = this.alertSvc.alertText$
    .pipe(tap((res) => {
      if (res.length) {
        // this.clearAlert();
      }
    }));

  constructor(private alertSvc: AlertService) {
  }

  clearAlert(): void {
    setTimeout(() => {
      this.alertSvc.alertText.next('');
    }, 2000);
  }
}
